import { TConfig, TConfigInput } from '@@/auto/interfaces';

import { AUTO_DISCOUNTS } from '../../autoDiscounts';

function ToggleSCConfig(): DeepPartial<TConfigInput> {
  return {
    auto: (auto: TConfig['auto']) => ({
      ...auto,
      addOns: {
        ...auto.addOns,
        options: {
          ...auto.addOns.options,
          oem_parts: {
            copy: {
              label: 'OEM Parts',
            },
          },
        },
        getAddOns: () => [
          'towing_road_services',
          'loss_of_use',
          'ridesharing',
          'loan_lease_payoff',
          'oem_parts',
          'new_car_replacement',
        ],
      },
    }),
    autoDiscounts: [
      AUTO_DISCOUNTS.aeb,
      AUTO_DISCOUNTS.continuousInsurance,
      AUTO_DISCOUNTS.defensiveDriver,
      AUTO_DISCOUNTS.distantStudent,
      AUTO_DISCOUNTS.claimFree,
      AUTO_DISCOUNTS.goodStudent,
      AUTO_DISCOUNTS.homeowner,
      AUTO_DISCOUNTS.multiCar,
      AUTO_DISCOUNTS.multiPolicy,
      AUTO_DISCOUNTS.accidentFree,
      AUTO_DISCOUNTS.safeDriving,
      AUTO_DISCOUNTS.teenDriver,
      AUTO_DISCOUNTS.threeYearSafeDriving,
    ],
    billingCadenceConfig: (
      billingCadenceConfig: TConfig['billingCadenceConfig']
    ) => ({
      ...billingCadenceConfig,
      canRateChangeWithCadence: true,
      defaultBillingCadence: 'monthly',
    }),
    collectEmailViewConfig: (
      collectEmailViewConfig: TConfig['collectEmailViewConfig']
    ) => ({
      ...collectEmailViewConfig,
      subHeader: `We may use your email address for offers relating to this quote, other products or other services`,
    }),
    visibleCoverages: (visibleCoverages: TConfig['visibleCoverages']) => {
      return {
        ...visibleCoverages,
        protectionCoverages: [
          ...visibleCoverages.protectionCoverages.filter(
            ({ key }) =>
              ![
                'pet_passenger',
                'underinsured_motorist_bodily_injury_limit',
                'uninsured_motorist_property_damage_limit',
                'underinsured_motorist_property_damage_limit',
              ].includes(key)
          ),
          {
            label: 'Underinsured Motorist Bodily Injury',
            key: 'underinsured_motorist_bodily_injury_limit',
          },
          {
            label: 'Uninsured Motorist Property Damage',
            key: 'uninsured_motorist_property_damage_limit',
          },
          {
            label: 'Underinsured Motorist Property Damage',
            key: 'underinsured_motorist_property_damage_limit',
          },
          visibleCoverages.protectionCoverages.find(
            ({ key }) => key === 'pet_passenger'
          ),
        ],
      };
    },
    initialCoverageValues: (
      initialCoverageValues: TConfig['initialCoverageValues']
    ) => ({
      ...initialCoverageValues,
      loan_lease_payoff: 'false',
      loss_of_use: 'null',
      ridesharing: 'false',
    }),
    selfServiceConfig: {
      promoCardParagraphText: 'Save on auto when you combo.',
    },
  };
}
export default ToggleSCConfig;
